import { render, staticRenderFns } from "./FormTagsSeparators.vue?vue&type=template&id=377710ec"
import script from "./FormTagsSeparators.vue?vue&type=script&lang=js"
export * from "./FormTagsSeparators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports